import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// Д-4а: страж совместимости (public/compat-check.js) уже нарисовал честный
// экран и поставил флаг там, где чат не заработает. Бандл сюда доходит только
// в «полупроходных» браузерах (Safari 14, Chrome 67–74): синтаксис прошёл,
// а wasm-крипта — нет. Монтировать приложение поверх объяснения нельзя:
// React стёр бы его, и человек получил бы страницу, которая падает позже,
// молча, при первом же подъёме крипты.
if (!window.__TOTAL_UNSUPPORTED__) {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
      <App />
  );
}
